import React from 'react';
import FollowUpPlan from '../../containers/FollowUpPlan/FollowUpPlan';

export class FollowUpPlanPage extends React.Component {
  render() {
    return (
      <FollowUpPlan />
    );
  }
}